import { Component, Input, Output, ViewChild, ElementRef, EventEmitter, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';
// import { Observable, Subject, Subscription, BehaviorSubject } from 'rxjs/Rx';
import { timer, fromEvent } from 'rxjs';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { Subscription } from 'rxjs';
import { AppUtility } from '../../utils/utility';
// import 'rxjs/add/observable/merge';
import { merge } from 'rxjs';
import { take, skipUntil, filter } from 'rxjs/operators';

@Component({
    selector: 'al-popover',
    template: `
        <div #popOverContent class="al-popover al-popover-{{position}} al-popover-{{type}}" [ngClass]="contentClass" [class.shown]="visible$ | async" aria-expanded="false">
            <span class="visuallyhidden">{{beginPopoverAccessibilityText}}</span>
            <div class="al-popover-content ">
                <ng-content *ngIf="visible$ | async"></ng-content>
            </div>
            <span class="visuallyhidden">{{endPopoverAccessibilityText}}</span>
        </div>
    `
})

export class AlPopOverComponent implements AfterViewInit, OnDestroy {

    // track Original parent of popover when its visible
    private originalParent: Node;

    // track Original parent of popover when its visible
    private clickSubscription: Subscription;

    // Event listener storage for Mouse Enter and Mouse Leave event to unbind it on component destroy
    public mouseLeaveListener;
    public mouseEnterListener;

    // store elemet which opens popover
    public focusedElBeforeOpen: Element;

    // collect all focusable elements from popover html
    public focusableEls: any;

    // set documentEscapeListener
    public documentEscapeListener: Function;

    // set popover visible property
    public visible: boolean;

    // Check if Mouse is over tooltip content
    public mouseIsOver: boolean = false;

    // set accessibility text for screenreader as beginning of
    @Input() beginPopoverAccessibilityText: string = 'Beginning of popover content';

    // set accessibility text for screenreader as end of
    @Input() endPopoverAccessibilityText: string = 'End of popover content';

    // Dont hide popover on outside click
    @Input() keepOnClickOutside: boolean;

    // Set position of popover
    @Input() position: string;

    // Set Type of popover
    @Input() type: string = 'popover';

    // Set contentClass of popover
    @Input() contentClass: string;

    // Hide popover on mouseout on popover content
    @Input() hideOnMouseOut: boolean = true;

    // Set reference vaiable of popover as popOverContent
    @ViewChild('popOverContent', {static: false}) content: any;

    // IOS realted flag value, default false
    @Input() isIOSFlag: boolean = false;

    // Check whether operationg system is IOS
    public isDeviceIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    visible$: Subject<boolean> = new BehaviorSubject<boolean>(false);

    // Set width for popover
    @Input() width: string;

    public timer: any;

    /**
     * @constructs
     * Seting constructor method and required param
     *
     * @param _element
     * @param renderer
     *
     */
    constructor(private elRef: ElementRef, private renderer: Renderer2, private appUtility: AppUtility) { }

    /**
     * Checking popover view is initialized or not
     * Hiding popover for animation
     *
     * @event ngAfterViewInit
     *
     */
    ngAfterViewInit(): any {
        this.renderer.setStyle(this.content.nativeElement, 'opacity', '0');
        this.renderer.setStyle(this.content.nativeElement, 'visibility', 'hidden');

        // Set uniqId to each instance of al-popover
        this.renderer.setStyle(this.content.nativeElement, 'id', 'al-popover_' + Math.random().toString(36).substring(2));

        this.mouseEnterListener = this.renderer.listen(this.content.nativeElement, 'mouseenter', (event) => {
            this.mouseIsOver = true;
        });

        this.mouseLeaveListener = this.renderer.listen(this.content.nativeElement, 'mouseleave', (event) => {
            this.mouseIsOver = false;

            if (this.hideOnMouseOut === true) {
                clearInterval(this.timer);
                this.hidePopOver(event);
            }
        });

        return undefined;
    }

    getAvailableSpaceForPopover(el, event) {
        let aLeft, aRight, aTop, aBottom, targetBox;
        if (event) {
            let targetEle = event.target || event.srcElement;
            targetBox = targetEle.getBoundingClientRect();
        } else {
            targetBox = this.elRef.nativeElement.nextElementSibling.getBoundingClientRect();
        }
        aLeft = Math.floor(targetBox.left);
        aRight = Math.floor(window.innerWidth - (targetBox.left + targetBox.width));
        aTop = Math.floor(targetBox.top);
        aBottom = Math.floor(window.innerHeight - (targetBox.top + targetBox.height));
        // return [aLeft, aRight, aTop, aBottom, targetBox];
        return [aLeft, aRight, targetBox];
    }

    setPopOverStyle(el, event) {
        let targetBox, popoverWidth;
        if (event) {
            let targetEle = event.target || event.srcElement;
            targetBox = targetEle.getBoundingClientRect();
        } else {
            targetBox = this.elRef.nativeElement.nextElementSibling.getBoundingClientRect();
        }

        let tleft = Math.floor(targetBox.left);
        let tright = Math.floor(window.innerWidth - (targetBox.left + targetBox.width));
        let finalLeft = tleft > tright ? tleft : tright;
        let finalRight = tright > tleft ? tright : tleft;

        if (this.position === 'left') {
            popoverWidth = finalLeft - 44;
        }
        if (this.position === 'right') {
            popoverWidth = finalRight - 44;
        }
        return popoverWidth;
    }

    setPopOverPosition(el, event) {
        let left, top, right;
        let Offset = 20;
        // let targetEle = event.target || event.srcElement;
        let [L, R, TB] = this.getAvailableSpaceForPopover(el, event);

        if (L < 600 || R < 600) {
            el.style.maxWidth = this.setPopOverStyle(el, event) + 'px';
        }

        let PB = this.content.nativeElement.getBoundingClientRect();
        let LRTOP = (TB.top + window.pageYOffset) - (PB.height / 2) + (TB.height / 2);
        let TBLEFT = TB.left + (TB.width / 2) - (PB.width / 2);


        let viewportHeight = window.innerHeight > 0 ? window.innerHeight : document.documentElement.clientHeight;
        // let viewportWidth = window.innerWidth > 0 ? window.innerWidth : document.documentElement.clientWidth;

        switch (this.position) {
            case 'left':
                top = LRTOP;
                if (L > PB.width) {
                    left = (TB.left - PB.width) - Offset;
                    this.appUtility.replaceClass(el, 'al-popover-right', 'al-popover-left');
                } else {
                    left = (TB.left + TB.width) + Offset;
                    this.appUtility.replaceClass(el, 'al-popover-left', 'al-popover-right');
                }
                break;
            case 'right':
                top = LRTOP;
                left = (TB.left + TB.width) + Offset;
                this.appUtility.replaceClass(el, 'al-popover-left', 'al-popover-right');
                if (PB.width > R) {
                    left = (TB.left - PB.width) - Offset;
                    this.appUtility.replaceClass(el, 'al-popover-right', 'al-popover-left');
                }
                break;
            case 'bottom':
                left = TBLEFT;
                top = ((TB.top + window.pageYOffset) + TB.height) + Offset;
                right = (TB.left + TB.width) + (PB.width / 2);

                this.appUtility.replaceClass(el, 'al-popover-top', 'al-popover-bottom');

                // If bottom has less space then, show on top
                if ((viewportHeight - TB.top) < (PB.height + Offset)) {
                    top = ((viewportHeight - PB.height) + (window.scrollY ? window.scrollY : window.pageYOffset)) - (viewportHeight - TB.top) - Offset;
                    if (TB.top > (PB.height + Offset)) {
                        this.appUtility.replaceClass(el, 'al-popover-bottom', 'al-popover-top');
                    } else {
                        this.appUtility.replaceClass(el, 'al-popover-top', 'al-popover-bottom');
                    }
                }

                if (left < 0) {
                    left = TB.left;
                    el.classList.add('al-popover-top-left');
                    el.classList.remove('al-popover-top-right');
                } else {
                    left = TBLEFT;
                    el.classList.remove('al-popover-top-right');
                    el.classList.remove('al-popover-top-left');
                }

                if (right > window.innerWidth) {
                    left = TB.right - PB.width;
                    el.classList.add('al-popover-top-right');
                    el.classList.remove('al-popover-top-left');
                } else {
                    el.classList.remove('al-popover-top-right');
                }

                break;
            default:
                left = TBLEFT;
                top = ((TB.top + window.pageYOffset) - PB.height) - Offset;
                right = (TB.left + TB.width) + (PB.width / 2);

                this.appUtility.replaceClass(el, 'al-popover-bottom', 'al-popover-top');

                if (top < window.pageYOffset) {
                    top = ((TB.top + window.pageYOffset) + TB.height) + Offset;
                    this.appUtility.replaceClass(el, 'al-popover-top', 'al-popover-bottom');
                }

                if (right > window.outerWidth) {
                    left = TB.right - PB.width;
                    el.classList.add('al-popover-top-right');
                }

                if (left < 0) {
                    left = TB.left;
                    el.classList.add('al-popover-top-left');
                }
        }

        return [left, top];
    }

    /**
     * TODO: Not in use, Remove later
     * Bind get popover position based on passed position
     *
     * @method getPopOverPosition
     * @param el
     * @param event
     * @returns left and top value
     *
     */

    getPopOverPosition(el: any, event) {
        let left: number;
        let right: number;
        let top: number;
        let xOffset: number = 20;
        let yOffset: number = 20;
        let targetBox;
        let elementBox = this.content.nativeElement.getBoundingClientRect();
        el.classList.remove('al-popover-top-left');
        el.classList.remove('al-popover-top-right');
        if (event) {
            let targetEle = event.target || event.srcElement;
            targetBox = targetEle.getBoundingClientRect();
        } else {
            targetBox = this.elRef.nativeElement.nextElementSibling.getBoundingClientRect();
        }

        if (this.position === 'left') {

            left = (targetBox.left - elementBox.width) - xOffset;
            top = (targetBox.top + window.pageYOffset) - (elementBox.height / 2) + (targetBox.height / 2);

            if (left < 0) {
                left = (targetBox.left + targetBox.width) + xOffset;
                el.classList.remove('al-popover-left');
                el.classList.add('al-popover-right');
            }

        } else if (this.position === 'right') {

            left = (targetBox.left + targetBox.width) + xOffset;
            top = (targetBox.top + window.pageYOffset) - (elementBox.height / 2) + (targetBox.height / 2);

            right = targetBox.right + elementBox.width;
            if (right > window.outerWidth) {
                left = (targetBox.left - elementBox.width) - xOffset;
                el.classList.add('al-popover-left');
                el.classList.remove('al-popover-right');
            }

        } else if (this.position === 'bottom') {

            left = targetBox.left + (targetBox.width / 2) - (elementBox.width / 2);
            top = ((targetBox.top + window.pageYOffset) + targetBox.height) + yOffset;

            if (left < 0) {
                left = targetBox.left;
                el.classList.add('al-popover-top-left');
            }

            right = targetBox.right + (elementBox.width / 2);
            if (right > window.outerWidth) {
                left = targetBox.right - elementBox.width;
                el.classList.add('al-popover-top-right');
            }

        } else if (this.position === 'top') {

            left = targetBox.left + (targetBox.width / 2) - (elementBox.width / 2);
            top = ((targetBox.top + window.pageYOffset) - elementBox.height) - yOffset;

            if (left < 0) {
                left = targetBox.left;
                el.classList.add('al-popover-top-left');
            }
            right = targetBox.right + (elementBox.width / 2);
            if (right > window.outerWidth) {
                left = targetBox.right - elementBox.width;
                el.classList.add('al-popover-top-right');
            }

        }

        return [left, top];
    }


    /**
     * Bind hide popover
     *
     * @method hidePopOver
     * @param event
     *
     */
    hidePopOver(event) {
        this.timer = setTimeout(() => {
            if (!this.mouseIsOver && this.visible) {
                /* if (event.type === 'mouseleave') {
                    if (this.mouseIsOver) {
                        this.renderer.setElementStyle(this.content.nativeElement, 'opacity', '1');
                        this.renderer.setElementStyle(this.content.nativeElement, 'visibility', 'inherit');
                        this.content.nativeElement.setAttribute('aria-expanded', 'true');
                    } else {
                        this.renderer.setElementStyle(this.content.nativeElement, 'opacity', '0');
                        this.renderer.setElementStyle(this.content.nativeElement, 'visibility', 'hidden');
                        this.content.nativeElement.setAttribute('aria-expanded', 'false');

                    }
                } else { */
                this.renderer.setStyle(this.content.nativeElement, 'opacity', '0');
                this.renderer.setStyle(this.content.nativeElement, 'visibility', 'hidden');
                this.renderer.setStyle(this.content.nativeElement, 'top', '-10000px');
                this.renderer.setStyle(this.content.nativeElement, 'left', '-10000px');
                this.content.nativeElement.setAttribute('aria-expanded', 'false');
                this.visible$.next(false);
                this.originalParent && this.originalParent.appendChild(this.content.nativeElement);
                this.visible = false;
                // }

                if ((this.focusedElBeforeOpen as HTMLElement)) {
                    (this.focusedElBeforeOpen as HTMLElement).focus();
                }
            }
        }, 200);

    }

    /**
     * Bind show popover
     *
     * @method showPopOver
     * @param event
     *
     */
    showPopOver(event) {
        clearInterval(this.timer);
        this.clickSubscription && this.clickSubscription.unsubscribe();
        this.visible$.next(true);
        let el = this.content.nativeElement;
        this.originalParent = el.parentNode;
        el.style.width = this.width;

        document.body.insertBefore(el, document.body.firstChild);
        this.renderer.setAttribute(this.content.nativeElement, 'visibility', 'inherit');
        timer(0).pipe(take(1)).subscribe(() => {
            // let [x, y] = this.getPopOverPosition(el, event);
            let [x, y] = this.setPopOverPosition(el, event);
            this.renderer.setStyle(el, 'top', y + 'px');
            this.renderer.setStyle(el, 'left', x + 'px');
            this.renderer.setStyle(el, 'opacity', '1');
            this.renderer.setStyle(el, 'visibility', 'visible');
            this.content.nativeElement.setAttribute('aria-expanded', 'true');
            this.focusedElBeforeOpen = event.target;
            this.manageAccessibility();
            this.bindDocumentEscapeListener();

            if (!this.keepOnClickOutside && !this.isIOSFlag && !this.isDeviceIOS) {
                // PCA-6409 fix for tooltip not closed on outside click on devices.
                const clickEvent$ = fromEvent(el.ownerDocument, 'click');
                const touchStartEvent$ = fromEvent(el.ownerDocument, 'touchstart');
                const allEvents$ = merge(clickEvent$, touchStartEvent$);
                this.clickSubscription = allEvents$.pipe(skipUntil(timer(0)))
                .pipe(filter((md: MouseEvent) => !el.contains(md.target)))
                    .pipe(take(1))
                    .subscribe((v) => (this.hidePopOver(event)));
                /* this.clickSubscription = fromEvent(el.ownerDocument, 'click')
                    .skipUntil(Observable.timer(0))
                    .filter((md: MouseEvent) => !el.contains(md.target))
                    .take(1)
                    .subscribe((v) => (this.hidePopOver(event))); */
            }
        });

        this.visible = true;
    }

    /**
     * Bind Toggle event to show/hide popover
     *
     * @method togglePopOver
     * @param event
     *
     */
    togglePopOver(event) {
        this.visible$
            .pipe(take(1))
            .subscribe((visible: boolean) => (visible ? this.hidePopOver(event) : this.showPopOver(event)));
    }

    /**
     * Bind Accessibility and manage focus inside popover itself on tab/shift-tab
     *
     * @method manageAccessibility
     *
     */
    manageAccessibility() {
        let focusableEls = this.content.nativeElement.querySelectorAll('a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])');
        this.focusableEls = Array.prototype.slice.call(focusableEls);

        let firstElement = this.focusableEls[0];
        let getLength = this.focusableEls.length - 1;
        let lastElement = this.focusableEls[getLength];
        if (firstElement) {
            firstElement.focus();
        } else {
            this.content.nativeElement.setAttribute('tabindex', '0');
            setTimeout(() => {
                this.content.nativeElement.focus();
            }, 10);
        }

        /* check last and first element of dialog is focusable or not */
        if (lastElement && firstElement) {

            /*redirect last tab to first input*/
            lastElement.addEventListener('keydown', (e) => {
                if ((e.which === 9 && !e.shiftKey)) {
                    e.preventDefault();
                    firstElement.focus();
                }
            });

            /*redirect first shift+tab to last input*/
            firstElement.addEventListener('keydown', (e) => {
                if ((e.which === 9 && e.shiftKey)) {
                    e.preventDefault();
                    lastElement.focus();
                }
            });

        }
    }

    /**
     * Binding escape lister to document for closing popover
     *
     * @method bindDocumentEscapeListener
     *
     */

    bindDocumentEscapeListener() {
        this.documentEscapeListener = this.renderer.listen('document', 'keydown', (event) => {
            if (event.which === 27 && this.visible) {
                this.hidePopOver(event);
            }
        });
    }

    ngOnDestroy() {
        // Remove mouseLeaveListener
        if (this.mouseLeaveListener) {
            this.mouseLeaveListener();
        }

        // Remove mouseEnterListener
        if (this.mouseEnterListener) {
            this.mouseEnterListener();
        }
    }

}
